import React from "react";
import _ from "lodash";
import { iTableColumns } from '../components/iTableProps';

interface extraFilterProp {
  isSort?: boolean,
  sortInfo?: any,
  sort?:any
}

function generateColumnSort (columns, extraProps:extraFilterProp = {}) {
  const { sortInfo = [], isSort } = extraProps;
  if (isSort) {
    const sortDic = {};
    sortInfo.forEach((item) => {
      sortDic[item.field] = { ...item };
    })
    return columns.map((item) => {
      return {
        ...item,
        ...(sortDic[item.dataIndex] || {})
      }
    })
  } else {
    return columns;
  }
}

export function getColumns (columns:iTableColumns[] = [], children:React.ReactNode, extraProps:extraFilterProp = {}) {
  if (columns && columns.length) {
    return generateColumnSort(columns, extraProps);
  }
  if (children) {
    const childrenColumns:iTableColumns[] = [];
    _.forEach(_.isArray(children) ? children : [children], function (child, rowIndex) {
      console.log(child, 'child')
      if (child.type && (child.type.TagName === "DataTableColumn")) {
        if (child.props.children) {
          child.props.children = getColumns(columns, child.props.children, extraProps);
        }
        childrenColumns.push(child.props)
      }
    });
    return generateColumnSort(childrenColumns, extraProps)
  }

  return [];
}
